import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  uuid: null,
  name: '',
  welcomeMessage: '',
  color: '',
};

const selectedCampaign = createSlice({
  name: 'selectedCampaign',
  initialState,
  reducers: {
    selectCampaign(_, { payload }) {
      return {
        uuid: payload.uuid,
        name: payload.name,
        welcomeMessage: payload.welcomeMessage,
        color: payload.color,
      };
    },
  },
});

export const { selectCampaign } = selectedCampaign.actions;
export default selectedCampaign.reducer;
